import React, { useState, useEffect, useContext } from "react";
import Header from "../../Components/Header/Header";
import { useNavigate, useParams } from "react-router-dom";
import useComplaintCategory from "../../Hooks/useComplaintCategory";
import toast, { Toaster } from "react-hot-toast";
import { AppContext } from "../../Context/AppContext";
import { PulseLoader } from "react-spinners";
import Backbutton from "../../Components/Header/Backbutton";
import Rating from "@mui/material/Rating";

function EditComplaintCategory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    complaintCategoryList,
    categoryLoading,
    getComplaintCategory,
    addComplaintCategory,
  } = useContext(AppContext);

  const [complaintCategories, setComplaintCategories] = useState({
    complaintCategoryName: "",
    complaintCategoryId: "",
    complaintCategoryDescription: "",
    score: 0,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    findComplaintCategory();
  }, [complaintCategoryList]);

  const findComplaintCategory = () => {
    if (!id) return;

    const complaintCategory = complaintCategoryList.find((x) => x._id == id);

    // if (!complaintCategory) return;
    setComplaintCategories((prev) => ({
      ...prev,
      complaintCategoryId: id,
      complaintCategoryName: complaintCategory?.complaintCategoryName ?? "",
      complaintCategoryDescription:
        complaintCategory?.complaintCategoryDescription ?? "",
      score: complaintCategory?.score ?? 0,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e;
    setComplaintCategories((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (complaintCategories && complaintCategories.score > 0) {
      const reviewTitle = "⭐".repeat(complaintCategories.score);
      setComplaintCategories((prevState) => ({
        ...prevState,
        complaintCategoryName: reviewTitle,
      }));
    }
  }, [complaintCategories?.score]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    await addComplaintCategory(complaintCategories, {
      onSuccess: async (res) => {
        setLoading(false);
        await getComplaintCategory();
        toast.success("Edited Successfully!");

        setTimeout(() => {
          navigate("/complaint-category");
        }, 1000);
      },
      onFailed: (err) => {
        setLoading(false);
        const errorMsg = err?.data || "Something went wrong!";
        toast.error(errorMsg);
        console.log(err);
      },
    });
  };

  return (
    <div className="container-fluid background">
      <Toaster position="top-center" />
      <Header />
      <div className="mains">
        <div class="edit-title data mb-3">
          <div class="start-edit">
            <Backbutton />
          </div>
          <div class="center-edit text-center">
            <h4 class="dash-head text-center">Edit Complaint Category</h4>
          </div>
        </div>
        <div className="add-category">
          <div className="card review_card edit_card">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="categoryName" className="form-label">
                  Review Rating
                </label>
                <br />
                {/* <input
                  name="complaintCategoryName"
                  type="text"
                  className="form-control"
                  id="categoryName"
                  value={complaintCategories?.complaintCategoryName ?? "N/A"}
                  onChange={(e) => handleChange(e.target)}
                /> */}
                <Rating
                  name="score"
                  value={complaintCategories.score}
                  onChange={(e) => handleChange(e.target)}
                  size="large"
                  className="fs-1"
                  disabled={loading}
                />
                <br />
                {complaintCategories.score < 0 && (
                  <span style={{ color: "red" }}>
                    Review Rating Name is Required!
                  </span>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="categoryDescription" className="form-label">
                  Description
                </label>
                <input
                  name="complaintCategoryDescription"
                  type="text"
                  className="form-control"
                  id="categoryDescription"
                  value={
                    complaintCategories?.complaintCategoryDescription ?? "N/A"
                  }
                  onChange={(e) => handleChange(e.target)}
                />
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="btn btn-danger"
                  disabled={loading}
                >
                  {loading ? <PulseLoader color="#fff" size={10} /> : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditComplaintCategory;
